import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

import SectionHeader, {
	type SectionHeaderProps,
} from '@ivy/components/molecules/SectionHeader';

import useAcepSectionTooltip from './useAcepSectionTooltip';

export interface AcepTableItem {
	icon: React.ReactNode;
	label: string;
	value: React.ReactNode;
}

export interface AcepTableSectionProps extends SectionHeaderProps {
	items?: AcepTableItem[];
}

const AcepTableSection = ({ items, ...props }: AcepTableSectionProps) => {
	const tooltip = useAcepSectionTooltip();
	return (
		<SectionHeader tooltipContent={tooltip} noBackground={!items} {...props}>
			{!items ? (
				<Typography variant='body1' color='text.icon' fontStyle='italic'>
					There is nothing here yet.
				</Typography>
			) : (
				<Stack spacing={3}>
					{items.map((el) => (
						<Box
							key={el.label}
							sx={{
								display: {
									sm: 'flex',
								},
								alignItems: {
									sm: 'start',
								},
							}}
						>
							<Box
								sx={{
									display: 'flex',
									alignItems: 'start',
								}}
							>
								<Box
									sx={{
										color: 'text.icon',
										mr: 1,
									}}
								>
									{el.icon}
								</Box>
								<Typography
									variant='body1'
									color='text.icon'
									sx={{
										width: {
											sm: '175px',
										},
									}}
								>
									{el.label}
								</Typography>
							</Box>
							<Typography
								variant='body1'
								fontWeight='bold'
								sx={{
									ml: {
										sm: 1,
									},
									mt: {
										xs: 1,
										sm: 0,
									},
									pl: {
										xs: 'calc(1.5rem + 8px)',
										sm: 0,
									},
									whiteSpace: 'pre-wrap',
								}}
							>
								{el.value}
							</Typography>
						</Box>
					))}
				</Stack>
			)}
		</SectionHeader>
	);
};

export default AcepTableSection;
